import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useForm } from 'react-hook-form';
import { CognitoUser, AuthenticationDetails } from "amazon-cognito-identity-js";
import UserPool from './UserPool';
import { AccessToken, RefreshToken } from './AccessToken';
import LoginImg from '../../assets/img/hlthtek-login.jpeg';
import LoginImg2 from '../../assets/img/hlthtek_login.jpg';
import { ChangeCursor } from '../hlthtek-demo/components/MiscFunctions';
import InfoVideo from '../../assets/abha_info.mp4';
import { toast } from 'react-toastify';

function Register() {
    const { register, handleSubmit, formState: { errors }, watch } = useForm();
    const { register: register1, handleSubmit: handleSubmit1, formState: { errors: errors1 }, watch: watch1 } = useForm();
    const history = useHistory()
    const [user, setUser] = useState("");
    const [password, setPassword] = useState("");
    const [verifyCodeForm, setVerifyCodeForm] = useState(false);

    useEffect(() => {
        sessionStorage.clear()
    }, [])

    const onSubmit = async (data) => {
        ChangeCursor()
        // setVerifyCodeForm(true)
        const cognitoUser = new CognitoUser({
            Username: data.userName,
            Pool: UserPool,
        });

        const authDetails = new AuthenticationDetails({
            Username: data.userName,
            Password: data.password,
        });

        setUser(data.userName)
        setPassword(data.password)
        try {
            cognitoUser.authenticateUser(authDetails, {
                onSuccess: () => {
                    cognitoUser.getAttributeVerificationCode("email", {
                        onSuccess: (success) => {
                            console.log(success)
                            setVerifyCodeForm(true)
                            ChangeCursor()
                        },
                        onFailure: (err) => {
                            console.log(err.message)
                            toast.error(err)
                            ChangeCursor()
                        }
                    });
                },
                onFailure: (err) => {
                    if (err.code === "UserNotConfirmedException") {
                        console.log("User account is not confirmed yet, please follow a link sent to your gmail to confirm you account!")
                        toast.error("User account is not confirmed yet, please follow a link sent to your gmail to confirm you account!")
                    }
                    else {
                        console.log(err.message)
                        toast.error(err.message)
                    }
                    ChangeCursor()
                }
            })
        }
        catch (error) {
            if (error === 'Error: Network Error') {
                console.log("System is under maintenance.Please try again.")
                toast.error("System is under maintenance.Please try again.")
            } else {
                console.log("Invalid user or password.")
                toast.error("Invalid user or password.")
            }
            ChangeCursor()
        }

    }

    const onSubmit1 = async (data) => {
        ChangeCursor()
        var role = "";
        var email = "";
        var name = "";
        var facility_name = "";

        const cognitoUser = new CognitoUser({
            Username: user,
            Pool: UserPool,
        });

        const authDetails = new AuthenticationDetails({
            Username: user,
            Password: password,
        });

        try {
            cognitoUser.authenticateUser(authDetails, {
                onSuccess: () => {
                    cognitoUser.verifyAttribute("email", data.verifyCode, {
                        onSuccess: () => {
                            cognitoUser.getUserAttributes(function (err, result) {
                                if (err) {
                                    toast.error(err.message || JSON.stringify(err));
                                    ChangeCursor()
                                    return;
                                }
                                else {
                                    console.log(result)
                                    sessionStorage.setItem("userName", user);
                                    for (var i = 0; i < result.length; i++) {
                                        if (result[i].getName() == "custom:role") {
                                            role = result[i].getValue();
                                            sessionStorage.setItem("roleType", role);
                                        }
                                        if (result[i].getName() == "custom:name") {
                                            name = result[i].getValue();
                                            sessionStorage.setItem("name", name);
                                        }
                                        if (result[i].getName() == "custom:facility_name") {
                                            facility_name = result[i].getValue();
                                            sessionStorage.setItem("facility_name", facility_name);
                                        }
                                        if (result[i].getName() === "email") {
                                            email = result[i].getValue();
                                            sessionStorage.setItem("email", email);
                                        }
                                    }
                                    if (role === "admin") {
                                        AccessToken(user, password)
                                        setTimeout(() => {
                                            ChangeCursor()
                                            history.push('/hlthtek-admin-demo')
                                        }, 2000)
                                    } else {
                                        AccessToken(user, password)
                                        setTimeout(() => {
                                            ChangeCursor()
                                            history.push('/hlthtek-demo')
                                        }, 2000)
                                    }
                                }
                            })
                        },
                        onFailure: (err) => {
                            console.log(err.message)
                            toast.error(err.message)
                            ChangeCursor()
                        }
                    })
                },
                onFailure: (err) => {
                    console.log(err.message)
                    toast.error(err.message)
                    ChangeCursor()
                }
            })
        }
        catch (error) {
            if (error === 'Error: Network Error') {
                console.log("System is under maintenance.Please try again.")
                toast.error("System is under maintenance.Please try again.")
            } else {
                toast.error("Invalid user or password.")
                console.log("Invalid user or password.")
            }
            ChangeCursor()
        }
    }
    const resendCode = () => {
        ChangeCursor()
        const cognitoUser = new CognitoUser({
            Username: user,
            Pool: UserPool,
        });

        const authDetails = new AuthenticationDetails({
            Username: user,
            Password: password,
        });
        cognitoUser.authenticateUser(authDetails, {
            onSuccess: () => {
                cognitoUser.getAttributeVerificationCode("email", {
                    onSuccess: (success) => {
                        console.log(success)
                        setVerifyCodeForm(true)
                        ChangeCursor()
                    },
                    onFailure: (err) => {
                        console.log(err.message)
                        toast.error(err)
                        ChangeCursor()
                    }
                });
            },
            onFailure: (err) => {
                if (err.code === "UserNotConfirmedException") {
                    console.log("User account is not confirmed yet, please follow a link sent to your gmail to confirm you account!")
                    toast.error("User account is not confirmed yet, please follow a link sent to your gmail to confirm you account!")
                }
                else {
                    console.log(err.message)
                    toast.error(err.message)
                }
                ChangeCursor()
            }
        })
    }

    const handlePlay = () => {
        let vid = document.getElementById("myVideo");
        if (vid.paused) {
            vid.play()
        } else {
            vid.pause()
        }
    }
    return (
        <div className="signupbox">
            {
                 <div className="wrapper">
                 <div className="footer" style={{ display: 'flex', flexDirection: 'row' }}>
                     <div style={{ paddingLeft: '2%', paddingTop: "50px", display: 'flex', flexDirection: 'column', justifyItems: 'center', alignItems: 'center' }}>
                         <video id="myVideo" src={InfoVideo} height={"80%"} width={"80%"} controls="controls" onClick={() => handlePlay()} autoplay="true" type='video/mp4' />
                         <div style={{ fontWeight: 'bolder', color: '#213360', fontSize: '20px', justifySelf: 'center' }}>
                             ABHA for Digital Health Records
                         </div>
                     </div>

                     <div style={{ paddingTop: '50px', paddingBottom: '35px', width: '50%' }}>
                         <div className="container" >
                             <div className="col-sm-12 col-md-12 col-lg-12" >
                                 <div className="footer-widget-contact" style={{ background: '#ebe9e4' }}>
                                     <h6 className="footer-widget__title color-heading">Hi, <span>Welcome!</span></h6>
                                     <form className="contact-list list-unstyled" name="login" id="login" onSubmit={handleSubmit(onSubmit)}>
                                         <li><h5>Register yourself to continue...</h5></li>
                                         <li>
                                             <div className="col-sm-12 col-md-12 col-lg-12">
                                                 <input name="userName" type="text" className="form-control" required={true} Placeholder='Username' {...register("userName", {
                                                     required: "Username is required.",
                                                 })} />
                                             </div>
                                         </li>
                                         <li>
                                             <div className="col-sm-12 col-md-12 col-lg-12">
                                                 <input name="password" className="form-control" type="password" required={true} Placeholder='Password' {...register("password", {
                                                     required: "Password is required.",
                                                 })} />
                                             </div>
                                         </li>
                                         <div className="col-sm-12 col-md-12 col-lg-12">
                                            {/* <i className="icon-user form-group-icon"></i> */}
                                            <select className="form-control"  {...register("role", {
                                                     required: "Role is required.",
                                                 })}>
                                            <option value="0">Choose Role</option>
                                            <option value="1">Admin</option>
                                            <option value="2">User</option>
                                            <option value="3">Partner</option>
                                            <option value="3">Customer</option>
                                            <option value="4">Facility Admin</option>
                                            <option value="4">Facility User</option>
                                            </select>
                                        </div>
                                         <li>
                                             <div className="col-sm-12 col-md-12 col-lg-12">
                                                 <input name="password" className="form-control" type="facility_name" required={true} Placeholder='Facility Name' {...register("facility_name", {
                                                     required: "Facility Name is required.",
                                                 })} />
                                             </div>
                                         </li>
                                         <li>
                                             <div className="col-sm-12 col-md-12 col-lg-12" style={{ paddingLeft: '25%' }}>
                                                 <button className='btn btn__secondary  mt-10' type="submit">Submit</button>
                                             </div>
                                         </li>
                                     </form>
                                     <div className="d-flex align-items-center" style={{ paddingTop: '20px' }}>
                                     Already have an account? 
                                         <a href="/login" className="btn btn__primary btn__link mr-30">
                                             <i className="icon-arrow-right"></i> <span>Login from here</span>
                                         </a>
                                     </div>
                                     <div className="d-flex align-items-center" style={{ paddingTop: '20px' }}>
                                         <a href="#" className="btn btn__primary btn__link mr-30">
                                             <i className="icon-arrow-right"></i> <span>Get Directions</span>
                                         </a>
                                         <ul className="social-icons list-unstyled mb-0">
                                             <li><a href="#"><i className="fab fa-facebook-f"></i></a></li>
                                             <li><a href="#"><i className="fab fa-instagram"></i></a></li>
                                             <li><a href="#"><i className="fab fa-twitter"></i></a></li>
                                         </ul>
                                     </div>
                                 </div>
                             </div>
                         </div>
                     </div>
                 </div>
             </div>
            }
        </div>
    )
}

export default Register